import React, { ReactNode } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import useLocalStorage from '../hooks/useLocalStorage'
import Path from './localRoutes'

interface ProtectedRouteProps {
  children?: ReactNode
  allowedRoles: string[]
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const [roleValue] = useLocalStorage('role')
  const [token] = useLocalStorage('token')

  const role = roleValue

  if (!token || !token.length) {
    if (!role) {
      return <Navigate to={Path.Root} replace />
    } else {
      return <Navigate to={Path.Signin} replace />
    }
  }

  if (allowedRoles.length && !allowedRoles.includes(role || '')) {
    return <Navigate to={Path.Root} replace />
  }

  return token && token.length ? children ? <>{children}</> : <Outlet /> : null
}

export default ProtectedRoute
